import React, { useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  TabContainer,
  TabContent,
  Row,
  Col,
  Nav,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import TemplateFullconfig from "./template-fullconfig";
import { toastAlert } from "../../utils/toast";
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

function RegistrationFullconfig(props) {
  const { RegisterForm, setRegisterForm, error, webinarId } = props;
  const {
    meetingType,
    templateId,
    firstName,
    Lastname,
    email,
    phone,
    registrationFees,
    hasRegistration,
    hasPassword,
    notiMailId,
    masterpassword,
    notifylist,
    hasNotified,
  } = RegisterForm;

  useEffect(() => {}, [RegisterForm]);

  console.log(RegisterForm, "RegisterForm");
  const [showTab1, setShowTab1] = useState(true);
  const [showTab2, setShowTab2] = useState(false);

  const [activeTab, setActiveTab] = useState(hasRegistration ? "tab2" : "tab1");

  const [feesTab, setFeesTab] = useState(hasRegistration ? true : false);

  const toggleTab1 = () => {
    setShowTab1(true);
    setShowTab2(false);
    setActiveTab("tab1");
    setRegisterForm({ ...RegisterForm, notiMailId: "" });
  };

  const toggleTab2 = () => {
    setShowTab1(false);
    setShowTab2(true);
    setActiveTab("tab2");
  };

  const [showPasswordprotectionTab1, setShowPasswordprotectionTab1] =
    useState(true);
  const [showPasswordprotectionTab2, setShowPasswordprotectionTab2] =
    useState(false);
  const [activeTab1, setActiveTab1] = useState("PasswordprotectionTab1");

  const togglePasswordprotectionTab1 = () => {
    setShowPasswordprotectionTab1(true);
    setShowPasswordprotectionTab2(false);
    setActiveTab1("PasswordprotectionTab1");
  };

  const togglePasswordprotectionTab2 = () => {
    setShowPasswordprotectionTab1(false);
    setShowPasswordprotectionTab2(true);
    setActiveTab1("PasswordprotectionTab2");
  };
  const [showMasterPassword1, setShowMasterPassword1] = useState(false);
  const [showMasterPassword2, setShowMasterPassword2] = useState(false);
  const toggleMasterPassword1 = () => {
    setShowMasterPassword1(true);
    setShowMasterPassword2(false);
  };
  const toggleMasterPassword2 = () => {
    setShowMasterPassword1(false);
  };

  const changeHandler = async (id) => {
    // const { id } = e.target
    console.log(id, "id");
    if (id == "Firstname" || id == "Email") {
      toastAlert("warning", `${id} are manditatory`);
      return false;
    }
    setRegisterForm({ ...RegisterForm, [id]: !RegisterForm[id] });
  };

  console.log(RegisterForm, "initialForm11111");

  const feesToogle = (type) => {
    if (type) {
      setFeesTab(true);
    }
  };

  console.log(feesTab, "feee");
  const [showregisterfreeTab1, setShowregisterfreeTab1] = useState(true);
  const [showregisterfreeTab2, setShowregisterfreeTab2] = useState(false);
  const [registeractiveTab1, setregisteractiveTab1] =
    useState("registerfreeTab1");

  const toggleregisterfreeTab1 = () => {
    setShowregisterfreeTab1(true);
    setShowregisterfreeTab2(false);
    setregisteractiveTab1("registerfreeTab1");
  };

  const toggleregisterfreeTab2 = () => {
    setShowregisterfreeTab1(false);
    setShowregisterfreeTab2(true);
    setregisteractiveTab1("registerfreeTab2");
  };

  console.log("activeTab", feesTab);
  return (
    <>
      <h2 className="head-field mt-2"> Registration page design</h2>
      <TemplateFullconfig
        webinarId={webinarId}
        templateId={templateId}
        meetingType={meetingType}
      />
      <h2 className="head-field mt-5"> Registration form fields</h2>
      <p>Add fields</p>
      <div className="Add_fields">
        <InputGroup
          className={
            firstName ? `mb-3 input-box-1 active` : "mb-3 input-box-1 "
          }
        >
          <Form.Control
            value="Firstname"
            aria-label="Recipient's username"
            aria-describedby="basic-addon2"
          />
          <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Add firstname</Tooltip>}>
          <Button id="button-addon2" onClick={() => changeHandler("Firstname")}>
            {" "}
            <img
              src={require("../../assets/images/acc-btn.png")}
              className="img-fluid"
            />
          </Button>
          </OverlayTrigger>
        </InputGroup>
        <InputGroup
          className={Lastname ? `mb-3 input-box-1 active` : "mb-3 input-box-1 "}
        >
          <Form.Control
            value="Lastname"
            aria-label="Recipient's username"
            aria-describedby="basic-addon2"
          />
          <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Add lastname</Tooltip>}>
          <Button id="button-addon2" onClick={() => changeHandler("Lastname")}>
            {" "}
            <img
              src={require("../../assets/images/acc-btn.png")}
              className="img-fluid"
            />
          </Button>
          </OverlayTrigger>
        </InputGroup>
        <InputGroup
          className={
            email == 1 ? `mb-3 input-box-1 active` : "mb-3 input-box-1 "
          }
        >
          <Form.Control
            value="Email"
            aria-label="Recipient's username"
            aria-describedby="basic-addon2"
          />
          <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Add email</Tooltip>}>
          <Button id="button-addon2" onClick={() => changeHandler("Email")}>
            {" "}
            <img
              src={require("../../assets/images/acc-btn.png")}
              className="img-fluid"
            />
          </Button>
          </OverlayTrigger>
        </InputGroup>
        <InputGroup
          className={
            phone == 1 ? `mb-3 input-box-1 active` : "mb-3 input-box-1 "
          }
        >
          <Form.Control
            value="phone"
            aria-label="Recipient's username"
            aria-describedby="basic-addon2"
          />
          <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Add phone number</Tooltip>}>
          <Button id="button-addon2" onClick={() => changeHandler("phone")}>
            {" "}
            <img
              src={require("../../assets/images/acc-btn.png")}
              className="img-fluid"
            />
          </Button>
          </OverlayTrigger>
        </InputGroup>
      </div>

      <div className="White_box_1 ">
        <div className="Mandatory_flelds">
          <p>Form fields</p>
          <div className="Add_fields_2">
            <p>Mandatory</p>
            <div class="Add_fields_2_content">
              <img
                src={require("../../assets/images/Mandatory_icon.png")}
                className="img-fluid"
              />
              <p>First Name</p>
            </div>
            {/* <div class="Add_fields_2_content active">
              <img
                src={require("../../assets/images/Mandatory_icon.png")}
                className="img-fluid"
              />
              <p>Last Name</p>
            </div> */}
            <div class="Add_fields_2_content">
              <img
                src={require("../../assets/images/Mandatory_icon.png")}
                className="img-fluid"
              />
              <p>Mail</p>
            </div>
            {/* <div class="Add_fields_2_content">
              <img
                src={require("../../assets/images/Mandatory_icon.png")}
                className="img-fluid"
              />
              <p>Phone</p>
            </div> */}
          </div>
        </div>
        <div className="Add_fields">
          {firstName == 1 && (
            <InputGroup className=" input-box-1 ">
              <InputGroup.Text id="basic-addon3">
                <img
                  src={require("../../assets/images/person_img.png")}
                  className="img-fluid"
                />
              </InputGroup.Text>
              <Form.Control
                placeholder="First name"
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                disabled
              />
              <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Close</Tooltip>}>
              <Button
                id="button-addon2"
                onClick={() => changeHandler("Firstname")}
              >
                {" "}
                <img
                  src={require("../../assets/images/close_img.png")}
                  className="img-fluid"
                />
              </Button>
              </OverlayTrigger>
            </InputGroup>
          )}
          {Lastname == 1 && (
            <InputGroup className=" input-box-1 ">
              <InputGroup.Text id="basic-addon3">
                <img
                  src={require("../../assets/images/person_img.png")}
                  className="img-fluid"
                />
              </InputGroup.Text>
              <Form.Control
                placeholder="Last name"
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                disabled
              />
              <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Close</Tooltip>}>
              <Button
                id="button-addon2"
                onClick={() => changeHandler("Lastname")}
              >
                {" "}
                <img
                  src={require("../../assets/images/close_img.png")}
                  className="img-fluid"
                />
              </Button>
              </OverlayTrigger>
            </InputGroup>
          )}

          {email == 1 && (
            <InputGroup className=" input-box-1 ">
              <InputGroup.Text id="basic-addon3">
                <img
                  src={require("../../assets/images/mail_img.png")}
                  className="img-fluid"
                />
              </InputGroup.Text>
              <Form.Control
                placeholder="Email address"
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                disabled
              />
              <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Close</Tooltip>}>
              <Button id="button-addon2" onClick={() => changeHandler("Email")}>
                {" "}
                <img
                  src={require("../../assets/images/close_img.png")}
                  className="img-fluid"
                />
              </Button>
              </OverlayTrigger>
            </InputGroup>
          )}
          {phone == 1 && (
            <InputGroup className=" input-box-1 ">
              <InputGroup.Text id="basic-addon3">
                <img
                  src={require("../../assets/images/mobile_img.png")}
                  className="img-fluid"
                />
              </InputGroup.Text>
              <Form.Control
                placeholder="Phone number"
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                disabled
              />
              <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Close</Tooltip>}>
              <Button id="button-addon2" onClick={() => changeHandler("phone")}>
                {" "}
                <img
                  src={require("../../assets/images/close_img.png")}
                  className="img-fluid"
                />
              </Button>
              </OverlayTrigger>
            </InputGroup>
          )}
        </div>
      </div>
      <h2 className="head-field mt-5">
        {" "}
        Free registration vs Paid registration
      </h2>
      <div class="  Auto_subscription">
        <div
          class="nav nav-pills "
          id="paid_registration"
          role="tablist"
          aria-orientation="vertical"
        >
          <div
            class="nav-link nav_link1 active"
            id="paid_registration-tab"
            data-bs-toggle="pill"
            data-bs-target="#p-paid_registration"
            // type="button"
            role="tab"
            aria-controls="v-paid_registration"
            aria-selected={registrationFees == 0 ? true : false}
            accessKey={feesTab}
          >
            <div
              class="form-check"
              onClick={() =>
                setRegisterForm({ ...RegisterForm, hasRegistration: false })
              }
            >
              <input
                className="form-check-input"
                type="radio"
                name="registerOptions1"
                id="registerNotification1"
                data-toggle="collapse"
                data-target="#registerfreeImg1"
                aria-expanded="false"
                aria-controls="registerfreeImg1"
                // checked={registeractiveTab1 === "registerfreeTab1"} // Check if registeractiveTab is "registerfreeTab1"
                checked={hasRegistration ? false : true}
              />
              <label
                className="form-check-label"
                htmlFor="registerNotification1"
              >
                <h6>It's free to register</h6>
                <p>The registration process is free of charge.</p>
              </label>
            </div>
          </div>

          <div
            class="nav-link nav_link1"
            id="paid_registration-tab_2"
            data-toggle="collapse"
            // data-target="#regfee"
            data-bs-toggle="pill"
            data-bs-target="#p-paid_registration_2"
            type="button"
            role="tab"
            aria-expanded="false"
            // aria-controls="notifyImg2"
            aria-controls="v-paid_registration_2"
            aria-selected={registrationFees != 0 ? true : false}
          >
            <div
              class="form-check"
              onClick={() =>
                setRegisterForm({ ...RegisterForm, hasRegistration: true })
              }
            >
              <input
                className="form-check-input"
                type="radio"
                name="registerOptions1"
                id="registerNotification2"
                data-toggle="collapse"
                data-target="#registerfreeImg2"
                aria-expanded="false"
                aria-controls="registerfreeImg2"
                checked={hasRegistration ? true : false}
                // checked={feesTab}
                // checked={registeractiveTab1 === "registerfreeTab2"} // Check if registeractiveTab is "registerfreeTab2"
              />
              <label
                className="form-check-label"
                htmlFor="registerNotification2"
              >
                <h6> Charge a registration fee</h6>
                <p>
                  Your users need to pay to complete their webinar registration.
                </p>
              </label>
            </div>
          </div>
        </div>
      </div>
      {hasRegistration && (
        <div className="collapse show tab-content-11-body">
          <div className="whitebox-content">
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">
                Registration Fees
              </label>
              <input
                type="number"
                class="form-control"
                id="exampleFormControlInput1"
                placeholder="Enter INR amount"
                value={registrationFees}
                onChange={(e) =>
                  setRegisterForm({
                    ...RegisterForm,
                    registrationFees: e.target.value,
                  })
                }
              />
            </div>

            {error && error.registrationFees && (
              <span style={{ color: "red" }}>{error.registrationFees}</span>
            )}
          </div>
          {/* <div className="whitebox-content">
            <label for="exampleFormControlInput1" class="form-label">
              Registration Fee
            </label>
            <div class="mb-3 select-text">
              <select aria-label="Default select example" class="form-select">
                <option>USD</option>
                <option value="1">EUR</option>
                <option value="2">GBP</option>
                <option value="3">JPY</option>
              </select>
              <input
                type="text"
                class="form-control"
                id="exampleFormControlInput1"
                placeholder="1"
              />
            </div>
            <Row>
              <Col lg="12" className="mb-2">
                <Form.Group className="" controlId="exampleForm.ControlInput1">
                  <Form.Label>Your payment checkout</Form.Label>
                  <h6 className="text-align2">
                    Enter the URL of your checkout page so we can redirect them
                    to submit their payment.
                  </h6>
                  <Form.Control type="text" placeholder="http://paypal.com" />
                </Form.Group>
                <p className="mt-2 text-align1">
                  Read this article to learn how to configure the payment flow.
                </p>
              </Col>
              <Col lg="12" className="select-text1 mb-2">
                <Form.Label>Post-payment redirect URL</Form.Label>
                <h6 className="text-align2">
                  This is the URL you should configure into your payment
                  processing system so your users come back to complete their
                  registration immediately upon submitting their payment.
                </h6>
                <InputGroup className="">
                  <Form.Control
                    value="https://event.vaffix.com/register/mzk5oaq2h3nql3416y/verified"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                  />
                  <InputGroup.Text id="basic-addon2">
                    <img
                      src={require("../../assets/images/copy.png")}
                      className="img-fluid"
                    />{" "}
                  </InputGroup.Text>
                </InputGroup>
                <p className="mt-2 text-align1">
                  Read this article to learn how to configure the payment flow.
                </p>
              </Col>
            </Row>
          </div> */}
        </div>
      )}

      <h2 className="head-field mt-5"> New registration notification</h2>

      <div class="tab_content_11">
        <div className=" tab_flex">
          <div
            className={`tab_content_1_sub ${!hasNotified ? "active" : ""}`}
            onClick={() =>
              setRegisterForm({ ...RegisterForm, hasNotified: false })
            }
          >
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="notificationOptions"
                id="noNotification"
                data-toggle="collapse"
                data-target="#notifyImg1"
                aria-expanded="false"
                aria-controls="notifyImg1"
                // checked={activeTab === "tab1"} // Check if activeTab is "tab1"
                checked={!hasNotified}
              />
              <label className="form-check-label" htmlFor="noNotification">
                <h6> No notification</h6>
                <p>
                  You will not receive an email notification when an attendee
                  registers to a webinar.
                </p>
              </label>
            </div>
          </div>

          <div
            className={`tab_content_1_sub2 ${hasNotified ? "active" : ""}`}
            onClick={() =>
              setRegisterForm({ ...RegisterForm, hasNotified: true })
            }

            // onClick={toggleTab2}
          >
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="notificationOptions"
                id="sendNotification"
                data-toggle="collapse"
                data-target="#notifyImg2"
                aria-expanded="false"
                aria-controls="notifyImg2"
                // checked={activeTab === "tab2"} // Check if activeTab is "tab2"
                checked={hasNotified}
              />
              <label className="form-check-label" htmlFor="sendNotification">
                <h6> Send notification</h6>
                <p>
                  You will be notified by email whenever an attendee registers
                  for a webinar.
                </p>
              </label>
            </div>
          </div>
        </div>

        <div className="tab-img img-bg">
          {!hasNotified && (
            <div className="collapse show ">
              <div>
                <img
                  src={require("../../assets/images/mail-transfer2.png")}
                  className="img-fluid"
                  alt="Notification Image 1"
                />
              </div>
            </div>
          )}

          {hasNotified && (
            <div className="collapse show ">
              <div>
                <img
                  src={require("../../assets/images/mail-transfer.png")}
                  className="img-fluid"
                  alt="Notification Image 2"
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {hasNotified && (
        <div className="select_box_1" id="notifyImg2">
          <Form.Label>Recipient's email</Form.Label>
          <Form.Select
            aria-label="Default select example"
            onChange={(e) =>
              setRegisterForm({ ...RegisterForm, notiMailId: e.target.value })
            }
          >
            {notiMailId != "" && notiMailId != "Select Email" ? (
              <>
                <option>Select Email</option>
                <option selected value={notiMailId}>
                  {notiMailId}
                </option>
              </>
            ) : (
              <>
                <option>Select Email</option>
                {notifylist.map((list) => (
                  <option value={list}>{list}</option>
                ))}
              </>
            )}
          </Form.Select>

          {error && error.notiMailId && (
            <span style={{ color: "red" }}>{error.notiMailId}</span>
          )}
        </div>
      )}

      <h2 className="head-field mt-5">Password protection</h2>

      <div class="tab_content_11">
        <div className="flex-tab-11">
          <div
            className={`tab_content_1_sub flex-grow-1 ${
              !hasPassword ? "active" : ""
            }`}
            onClick={() =>
              setRegisterForm({ ...RegisterForm, hasPassword: false })
            }
          >
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="notificationOptions1"
                id="noNotification1"
                data-toggle="collapse"
                data-target="#PasswordprotectionImg1"
                aria-expanded="false"
                aria-controls="PasswordprotectionImg1"
                // checked={activeTab1 === "PasswordprotectionTab1"} // Check if activeTab is "PasswordprotectionTab1"

                checked={!hasPassword ? true : false}
              />
              <label className="form-check-label" htmlFor="noNotification1">
                <h6>No password needed</h6>
                <p>
                  Anyone with a valid link will be able to access the webinar
                  room.
                </p>
              </label>
            </div>
          </div>

          <div
            className={`tab_content_1_sub2 ${hasPassword ? "active" : ""}`}
            onClick={() =>
              setRegisterForm({ ...RegisterForm, hasPassword: true })
            }

            // onClick={togglePasswordprotectionTab2}
          >
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="notificationOptions1"
                id="sendNotification1"
                data-toggle="collapse"
                data-target="#PasswordprotectionImg2"
                aria-expanded="false"
                aria-controls="PasswordprotectionImg2"
                // checked={activeTab1 === "PasswordprotectionTab2"} // Check if activeTab is "PasswordprotectionTab2"
                checked={hasPassword ? true : false}
              />
              <label className="form-check-label" htmlFor="sendNotification1">
                <h6> Password required</h6>
                <p>
                  Both a valid link and a secret password will be required to
                  enter the webinar room.
                </p>
              </label>
            </div>
          </div>
        </div>
      </div>

      {hasPassword && (
        <div className="collapse show tab-content-11-body">
          <div className="whitebox-content">
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">
                Master password
              </label>
              <input
                type="password"
                class="form-control"
                id="exampleFormControlInput1"
                placeholder="Enter your password"
                onChange={(e) =>
                  setRegisterForm({
                    ...RegisterForm,
                    masterpassword: e.target.value,
                  })
                }
              />
            </div>

            {error && error.password && (
              <span style={{ color: "red" }}>{error.password}</span>
            )}
          </div>
        </div>
      )}
    </>
  );
}
export default RegistrationFullconfig;
